import tw from 'tailwind-styled-components'

export const dialogPanel = `
w-full 
max-w-[565px]
transform 
overflow-hidden 
rounded-2xl 
bg-white 
p-8 
text-left 
align-middle 
shadow-xl 
transition-all
`
export const ButtonsContainer = tw.div`
flex gap-4 mt-8
`
export const ButtonAction = tw.button`
inline-flex
items-center
justify-center
h-[38px]
py-2
px-4
border
border-blueTheme
rounded-lg
text-sm
active:scale-95
transition-colors
cursor-pointer
hover:brightness-90
`
export const ContentContainer = tw.div`
flex
flex-col
justify-center
items-center
`